import { render, staticRenderFns } from "./UserProfileView.vue?vue&type=template&id=6750c70c&scoped=true&"
import script from "./UserProfileView.vue?vue&type=script&lang=ts&"
export * from "./UserProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileView.vue?vue&type=style&index=0&id=6750c70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6750c70c",
  null
  
)

export default component.exports